import React, { Component } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Input,
  Button,
  Label,
  CustomInput,
} from "reactstrap";

import {connect} from 'react-redux'
import {addMachineMoreInfo} from '../../store/actions/machineActions'

class AddMachineMoreInfo extends Component {
  state = {
    location: "",
    task: "",
    status: "Off",
    dateOffRd: "",
    remarks: "",
    unitInfo: true,
    id:this.props.machine.id
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleStatusSwitch = () => {
    if (this.state.status === "Off") {
      this.setState({
        status: "On",
      });
    } else {
      this.setState({
        status: "Off",
      });
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    console.log(this.state);
    this.props.addMachineMoreInfo(this.state)
  };

  render() {
    return (
      <div>
        <Card className="mt-3">
          <CardBody>
            <CardTitle>
              <h4 className="text-center">Add Machine More Details</h4>
            </CardTitle>
            <h5>UHA No: {this.props.machine.UHANo}</h5>
            <Form onSubmit={this.handleSubmit}>
              <FormGroup>
              <Label for="exampleDate">Location</Label>
                <Input
                  required
                  type="text"
                  name="location"
                  id="location"
                  placeholder="Ex: Sadahirusaya"
                  onChange={this.handleChange}
                />
              </FormGroup>

              <FormGroup>
              <Label for="exampleDate">Task</Label>
                <Input
                  required
                  type="text"
                  name="task"
                  id="task"
                  placeholder="Project Alpha"
                  onChange={this.handleChange}
                />
              </FormGroup>

                <FormGroup>
                <Label for="exampleDate">Machine Status</Label>
              <CustomInput
                type="switch"
                id="status"
                name="status"
                label=""
                onChange={this.handleStatusSwitch}
              />
              <label>Status is {this.state.status}</label>
              </FormGroup>


              <FormGroup>
                <Label for="exampleDate">Date Off RD</Label>
                <Input
                  type="date"
                  name="dateOffRd"
                  id="dateOffRd"
                  placeholder="date placeholder"
                  onChange={this.handleChange}
                />
              </FormGroup>

              <FormGroup>
                <Label for="remarks">Remarks</Label>
                <Input
                  type="textarea"
                  name="remarks"
                  id="remarks"
                  onChange={this.handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Button color="primary" block>
                  Add Now
                </Button>
              </FormGroup>
            </Form>
          </CardBody>
        </Card>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return{
    addMachineMoreInfo: (machine) => dispatch(addMachineMoreInfo(machine))
  }
}

export default connect(null, mapDispatchToProps)(AddMachineMoreInfo);
